import { computed, defineComponent, onBeforeUnmount, onMounted, reactive, ref, useCssModule, } from '@nuxtjs/composition-api';
export default defineComponent({
    name: 'ProfilePersonChart',
    props: {
        pre: {
            default: '',
            type: String,
        },
        sub: {
            default: '',
            type: String,
        },
        title: {
            default: 'Как менялось состояние',
            type: String,
        },
        wealthTitle: {
            default: 'Состояние',
            type: String,
        },
        wealths: {
            default: () => [],
            type: Array,
        },
    },
    setup(props) {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        const bars = computed(() => {
            const chartBars = [];
            const wealths = [];
            let left = -20;
            for (let i = 0, l = (props.wealths || []).length; i < l; i++) {
                const current = (props.wealths || [])[i];
                const previous = (props.wealths || [])[i - 1];
                const tooltip = {
                    [`${props.wealthTitle}:`]: current.val,
                };
                if (previous && previous.val !== current.val) {
                    const symbol = parseInt(previous.val, 10) > parseInt(current.val, 10) ? '-' : '+';
                    tooltip['Изменение:'] = symbol + Math.abs(current.val - previous.val);
                }
                left += 40;
                wealths.push(current.val);
                chartBars.push({
                    left,
                    tooltip,
                    year: current.year,
                });
            }
            const maxWealth = Math.max(...wealths);
            return chartBars.map((bar = {}) => {
                const value = bar.tooltip ? bar.tooltip[`${props.wealthTitle}:`] : 0;
                const percentage = (value * 100) / maxWealth;
                bar.height = value === maxWealth ? 100 : percentage;
                return bar;
            });
        });
        const chart = reactive({
            edge: 'left',
            isScrollable: false,
            scrollLeft: 0,
            scrollWidth: 0,
            width: 0,
        });
        const chartEl = ref();
        const currentBar = ref({ ...bars.value[0] });
        const resizeObserver = ref();
        const ticking = ref(false);
        function handleScroll() {
            if (!ticking.value) {
                window.requestAnimationFrame(() => {
                    ticking.value = false;
                    hideTooltip();
                    chart.scrollLeft = chartEl.value?.scrollLeft || 0;
                    switch (chart.scrollLeft) {
                        case 0:
                            chart.edge = 'left';
                            break;
                        case chart.scrollWidth - chart.width:
                            chart.edge = 'right';
                            break;
                        default:
                            chart.edge = '';
                    }
                });
            }
            ticking.value = true;
        }
        function goBackward() {
            chartEl.value?.scrollBy({ top: 0, left: -chart.width, behavior: 'smooth' });
        }
        function goForward() {
            chartEl.value?.scrollBy({ top: 0, left: chart.width, behavior: 'smooth' });
        }
        function hideTooltip() {
            currentBar.value = {
                ...currentBar.value,
                year: 0,
            };
        }
        function showTooltip(bar) {
            currentBar.value = bar;
            chart.scrollLeft = chartEl.value?.scrollLeft || 0;
        }
        onBeforeUnmount(() => {
            resizeObserver.value?.disconnect();
        });
        onMounted(() => {
            resizeObserver.value = new ResizeObserver(() => {
                if (!chartEl.value) {
                    return;
                }
                chart.width = chartEl.value.clientWidth;
                chart.scrollWidth = chartEl.value.scrollWidth;
                chart.isScrollable = chart.scrollWidth > chart.width + 4;
            });
            resizeObserver.value.observe(chartEl.value);
        });
        return {
            bars,
            chart,
            chartEl,
            css,
            currentBar,
            goBackward,
            goForward,
            handleScroll,
            hideTooltip,
            resizeObserver,
            showTooltip,
        };
    },
});
